export const version = "strings/5.0.7";
//# sourceMappingURL=_version.js.map